import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { PickerController, Platform, ModalController, IonFab } from '@ionic/angular';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio';
import { Observable } from 'rxjs';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.page.html',
  styleUrls: ['./settings-modal.page.scss'],
})
export class SettingsModalPage implements OnInit {

  public language: any;
  public displaying: string;
  faceid_available: boolean;
  touchid_available: boolean;
  faceid_saved: boolean;
  touchid_saved: boolean;
  public userJSON: any;
  public notifyInstructors: boolean;
  public notifyInstructor_history: any;
  public is_first_login: boolean;
  public is_student: boolean;
  public is_visitor: boolean;
  public empRef: AngularFireList<any>;
  empRefObj: AngularFireObject<any>;
  public emp: Observable<any[]>;
  public user_key: string;
  public script_response: any;
  public firebase_key: any;

  constructor(
    private storage: Storage,
    private pickerController: PickerController,
    public modalCtrl: ModalController,
    private _platform: Platform,
    public db: AngularFireDatabase,

  ) {
    this.displaying = "";
    this.touchid_saved = false;
    this.faceid_saved = false;
    this.notifyInstructors = false;


    this._platform.ready().then(() => {
      FingerprintAIO.isAvailable()
        .then(result => {
          if (result === "finger") {
            //Fingerprint Auth is available
            this.touchid_available = true;

          }
          if (result === "face") {
            //Fingerprint or Face Auth is available
            this.faceid_available = true;
          }
        })
        .catch((error: any) => {
          //Fingerprint/Face was not successfully verified
          console.log(error);
        });
    })

  }

  toogleSettings() {
    if (this.displaying == 'terms')
      this.displaying = '';
    else
      this.displaying = 'terms';
  }

  async ionViewDidEnter() {
    if(this.is_visitor){
      this.language = await this.storage.get('language');
      if(!this.language)
        this.language = "English";
      return;
    }
    this.firebase_key = await this.storage.get('firebase_key');
    this.language = await this.storage.get('language');
    this.faceid_saved = await this.storage.get('faceid_saved');
    this.touchid_saved = await this.storage.get('touchid_saved');
    this.userJSON = await this.storage.get('userJSON');
    console.log('here ----', this.userJSON);
    if (!this.firebase_key) {
      this.empRef = this.db.list('/employees', ref => ref.orderByChild('pid').equalTo(this.userJSON.pid));
      this.emp = this.empRef.snapshotChanges().pipe(
        map(changes =>
          changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
        )
      );

      this.emp.subscribe(res => {
        let employees = res;
        employees.forEach((item) => {
          this.user_key = item.key;
          this.notifyInstructors = (item.notifyInstructors && item.notifyInstructors == "Yes");
          this.notifyInstructor_history = (item.notifyInstructor_history) ? item.notifyInstructor_history : [];
        })
      }
      );
    }
    else { //cache fireabase user key
      this.empRefObj = this.db.object(`/employees/${this.firebase_key}`);
      this.emp = this.empRefObj.valueChanges();
      this.emp.subscribe(res => {
        console.log(res);
        this.script_response = res;
        let item = this.script_response;
        this.user_key = item.key;
        this.notifyInstructors = (item.notifyInstructors && item.notifyInstructors == "Yes");
        this.notifyInstructor_history = (item.notifyInstructor_history) ? item.notifyInstructor_history : [];
      }
      );
    }


    //alert(JSON.stringify(this.userJSON));
  }


  async setLanguage() {
    this.displaying = '';
    const picker = await this.pickerController.create({
      columns: [{
        name: 'Answer',
        options: [{ text: 'English', value: 'English' }, { text: 'Spanish', value: 'Spanish' }, { text: 'Creole', value: 'Creole' }]
      }],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: (option) => {
            console.log(option);
            this.language = option.Answer.value
          }
        }
      ]
    });

    await picker.present();
  }


  async setNotifyInstructors() {
    this.displaying = '';
    const picker = await this.pickerController.create({
      columns: [{
        name: 'Answer',
        options: [{ text: 'Yes', value: 'Yes' }, { text: 'No', value: 'No' }]
      }],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: (option) => {
            console.log(option);
            this.notifyInstructors = option.Answer.value
          }
        }
      ]
    });

    await picker.present();
  }


  async setFaceId() {
    this.displaying = '';
    const picker = await this.pickerController.create({
      columns: [{
        name: 'Answer',
        options: [{ text: 'Yes', value: true }, { text: 'No', value: false }]
      }],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: (option) => {
            console.log(option);
            this.faceid_saved = option.Answer.value;
          }
        }
      ]
    });

    await picker.present();
  }

  async setTouchId() {
    this.displaying = '';
    const picker = await this.pickerController.create({
      columns: [{
        name: 'Answer',
        options: [{ text: 'Yes', value: true }, { text: 'No', value: false }]
      }],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: (option) => {
            console.log(option);
            this.touchid_saved = option.Answer.value;
          }
        }
      ]
    });

    await picker.present();
  }

  async save() {
    await this.storage.set('language', this.language);
    await this.storage.set('faceid_saved', this.faceid_saved);
    await this.storage.set('touchid_saved', this.touchid_saved);
    if (this.is_student) {
      this.notifyInstructor_history.push({ time: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`, value: (this.notifyInstructors) ? "On" : "Off" })
      this.userJSON.notifyInstructors = (this.notifyInstructors) ? "Yes" : "No";
      if(this.empRef){
      await this.empRef.update(this.user_key, { notifyInstructors: (this.notifyInstructors) ? "Yes" : "No", notifyInstructor_history: this.notifyInstructor_history });
      }
      else if(this.empRefObj){
        await this.empRefObj.update({ notifyInstructors: (this.notifyInstructors) ? "Yes" : "No", notifyInstructor_history: this.notifyInstructor_history });
      }
      await this.storage.set('userJSON', this.userJSON);
    }
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }
  ngOnInit() {
  }

}
